import { render } from "./FooterSectionComponent.vue?vue&type=template&id=3fc75ff8&ts=true"
import script from "./FooterSectionComponent.vue?vue&type=script&lang=ts"
export * from "./FooterSectionComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__